<template>
  <div class="company-tags-chips">
    <span
      v-for="t in assignedTags"
      :key="t.id"
      class="chip"
      :style="{ backgroundColor: t.color }"
      :title="t.description"
    >
      {{ t.name }}
      <button v-if="editable" class="chip-remove" @click="unassign(t)">×</button>
    </span>

    <div v-if="editable" class="add-tag">
      <select v-model="pendingTagId" @change="onPick">
        <option value="">+ Adicionar tag</option>
        <option
          v-for="t in availableToAdd"
          :key="t.id"
          :value="t.id"
        >{{ t.name }}</option>
      </select>

      <button class="manage-btn" @click="openManageModal">Gerenciar tags</button>
    </div>
  </div>
</template>

<script>
import {
  COMPANY_TAGS,
  COMPANY_TAGS_BY_COMPANY,
  COMPANY_TAGS_ASSIGN,
  COMPANY_TAGS_UNASSIGN
} from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";
import swal from "sweetalert";

export default {
  name: "companyTagsChips",
  props: {
    companyId: { type: String, required: true },
    editable: { type: Boolean, default: true }
  },
  data() {
    return {
      allTags: [],
      assignedTags: [],
      pendingTagId: ""
    };
  },
  computed: {
    availableToAdd() {
      const assignedIds = new Set(this.assignedTags.map((t) => t.id));
      return this.allTags.filter((t) => !assignedIds.has(t.id));
    }
  },
  watch: {
    companyId: {
      immediate: true,
      handler(val) { if (val) this.load(); }
    }
  },
  methods: {
    load() {
      Promise.all([
        REQUEST_SERVICE.get(COMPANY_TAGS).then((r) => { this.allTags = r.data || []; }),
        REQUEST_SERVICE.get(`${COMPANY_TAGS_BY_COMPANY}/${this.companyId}`).then((r) => { this.assignedTags = r.data || []; })
      ]);
    },
    onPick() {
      if (!this.pendingTagId) return;
      const tagId = this.pendingTagId;
      this.pendingTagId = "";

      REQUEST_SERVICE.post(COMPANY_TAGS_ASSIGN, { tagId, companyId: this.companyId })
        .then(() => { this.load(); })
        .catch(() => { swal("Aviso", "Falha ao atribuir tag.", "error"); });
    },
    unassign(tag) {
      REQUEST_SERVICE.post(COMPANY_TAGS_UNASSIGN, { tagId: tag.id, companyId: this.companyId })
        .then(() => { this.load(); })
        .catch(() => { swal("Aviso", "Falha ao remover tag.", "error"); });
    },
    openManageModal() {
      $("#modalManageCompanyTags").modal();
    }
  }
};
</script>

<style lang="scss" scoped>
.company-tags-chips {
  display: flex; flex-wrap: wrap; gap: 6px; align-items: center; margin: 8px 0;

  .chip {
    color: #fff; font-size: 11px; padding: 3px 10px; border-radius: 12px;
    font-weight: 600; letter-spacing: 0.3px; display: inline-flex; align-items: center; gap: 4px;
  }
  .chip-remove {
    background: rgba(255,255,255,0.25); border: none; color: #fff;
    border-radius: 50%; width: 16px; height: 16px; line-height: 14px;
    cursor: pointer; padding: 0; font-weight: bold;
  }
  .chip-remove:hover { background: rgba(255,255,255,0.45); }

  .add-tag { display: flex; gap: 6px; align-items: center; margin-left: 6px; }
  .add-tag select {
    border: 1px solid #ddd; border-radius: 4px; padding: 2px 6px; font-size: 12px;
  }
  .manage-btn {
    background: transparent; border: 1px dashed #aaa; color: #555;
    padding: 2px 8px; border-radius: 4px; font-size: 11px; cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/companyTagsChips.vue